import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authContext from "contexts/auth/authContext";
import { ViewOnlyPermissionsProvider } from "contexts/view-only-permissions/view-only-permissions";
import { AlertProvider } from "contexts/alert/alert-provider";
import { SidePanelProvider } from "../contexts/side-panel/side-panel-provider";
import { useAllowedRoles } from "./hooks/api/use-allowed-roles";
import * as notify from "shared/notify";

export const PrivateRoute = ({ component: Component, allowedRoles = null, checkAllowedRoutes, checkPermission, ...rest }) => {
    const navigate = useNavigate();
    const { authenticated } = useContext(authContext);
    const { isProcessing, isAllowed } = useAllowedRoles(allowedRoles, checkAllowedRoutes, rest.path, checkPermission);

    useEffect(() => {
        if (!authenticated || (!isProcessing && !isAllowed)) {
            notify.error("You do not have permission to perform this action.");
            navigate("/");
        }
    }, [navigate, isAllowed, isProcessing, authenticated]);

    return (
        <AlertProvider>
            <SidePanelProvider>
                <ViewOnlyPermissionsProvider>
                    <Component {...rest} />
                </ViewOnlyPermissionsProvider>
            </SidePanelProvider>
        </AlertProvider>
    );
};
